import React, { useContext } from 'react'

import { useCollectionFilters } from '@/hooks/useCollectionFilters'
import type { CMSCollectionFilter } from '@/types/sanity'

import { FilterGroupMobile } from './FilterGroupMobile'
import { CollectionContext } from './collection-context'

import './FilterFlyout.scss'

type Props = {
  isFiltersMenuOpen: boolean
  closeFiltersMenu: () => void
  applyFilters: (filters: Record<string, CMSCollectionFilter>) => void
}

export const FilterFlyout: React.FC<Props> = ({
  closeFiltersMenu,
  applyFilters,
}) => {
  const { filters, activeGridItems, appliedFilters, collectionLinks } =
    useContext(CollectionContext)

  const {
    appliedFilters: filtersToApply,
    isFilterApplied,
    isFilterAvailable,
    hasFilterGroupAppliedFilter,
    handleFilterChange,
  } = useCollectionFilters({
    filters: filters,
    gridItems: activeGridItems,
    appliedFiltersDefault: appliedFilters,
  })

  const handleFiltersClear = () => {
    applyFilters({})
    closeFiltersMenu()
  }

  const handleFiltersApply = () => {
    applyFilters(filtersToApply)
    closeFiltersMenu()
  }

  return (
    <div className="collection-filter-flyout">
      <div className="collection-filter-flyout__body">
        {collectionLinks?.length && (
          <div className="collection-filter-links">
            {collectionLinks.map((collectionLink) => (
              <a
                className="collection-filter-links__item button button--tertiary"
                key={collectionLink._id}
                href={`/collections/${collectionLink.slug}`}
              >
                {collectionLink.title}
              </a>
            ))}
          </div>
        )}
        {filters?.map((filterGroup) => (
          <FilterGroupMobile
            key={filterGroup._id}
            filterGroup={filterGroup}
            isFilterApplied={isFilterApplied}
            isFilterAvailable={isFilterAvailable}
            handleFilterChange={handleFilterChange}
            isOpen={hasFilterGroupAppliedFilter(filterGroup)}
          />
        ))}
      </div>
      <div className="collection-filter-flyout__footer">
        <button
          className="collection-filter-flyout__clear-button button button--secondary"
          onClick={handleFiltersClear}
        >
          Clear
        </button>
        <button
          className="collection-filter-flyout__apply_button button button--primary"
          onClick={handleFiltersApply}
        >
          Apply
        </button>
      </div>
    </div>
  )
}
